import {
  IconFileInvoice, IconReceipt,
  IconBuildingBank, IconCreditCard, IconFileDescription,
  IconClock, IconCpu, IconCheck, IconX, IconAlertCircle
} from '@tabler/icons-react';

export const DOCUMENT_TYPES = [
  { value: 'invoice', label: 'Invoice' },
  { value: 'receipt', label: 'Receipt' },
  { value: 'bank_statement', label: 'Bank Statement' },
  { value: 'credit_note', label: 'Credit Note' },
  { value: 'debit_note', label: 'Debit Note' },
  { value: 'other', label: 'Other' }
];

export const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'pending', label: 'Pending' },
  { value: 'queued', label: 'Queued' },
  { value: 'processing', label: 'Processing' },
  { value: 'completed', label: 'Completed' },
  { value: 'failed', label: 'Failed' },
  { value: 'needs_review', label: 'Needs Review' }
];

export const APPROVAL_OPTIONS = [
  { value: '', label: 'All Approval' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'pending', label: 'Pending Review' }
];

export const TAG_COLORS = {
  vat: 'blue',
  capex: 'violet',
  opex: 'orange'
};

export const TAG_OPTIONS = [
  { value: 'vat', label: 'vat' },
  { value: 'capex', label: 'capex' },
  { value: 'opex', label: 'opex' }
];

export const TYPE_ICONS = {
  invoice: IconFileInvoice, receipt: IconReceipt,
  bank_statement: IconBuildingBank, credit_note: IconCreditCard,
  debit_note: IconCreditCard, other: IconFileDescription
};

export const TYPE_COLORS = {
  invoice: 'blue', receipt: 'green', bank_statement: 'violet',
  credit_note: 'yellow', debit_note: 'orange', other: 'gray'
};

export const STATUS_COLORS = {
  pending: 'gray', queued: 'cyan', processing: 'yellow',
  completed: 'green', failed: 'red', needs_review: 'orange'
};

export const STATUS_ICONS = {
  pending: IconClock, queued: IconClock, processing: IconCpu,
  completed: IconCheck, failed: IconX, needs_review: IconAlertCircle
};
